/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ApiMediaFilePayloadFromJSON(json) {
    return ApiMediaFilePayloadFromJSONTyped(json, false);
}
export function ApiMediaFilePayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fileType': !exists(json, 'fileType') ? undefined : json['fileType'],
        'fullPath': !exists(json, 'fullPath') ? undefined : json['fullPath'],
    };
}
export function ApiMediaFilePayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fileType': value.fileType,
        'fullPath': value.fullPath,
    };
}
